import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';
import CartDrawer from '../cart/CartDrawer';
import { useAuth } from '../../context/AuthContext';
import { ChatProvider } from '../../context/ChatContext';
import ChatWidget from '../chatbot/ChatWidget';

// App frame: sticky Header, routed page content, Footer. The page background
// token is applied on <body> in base.css; the container width is set per-page.
export default function Layout() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const isAdminRoute = pathname.startsWith('/admin');

  return (
    <div className="ss-app">
      <Header />
      <main className="ss-main">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      {/* chat is logged-in-only (chat_bot.md §3.4, §4) — the provider only
          mounts (and only then fetches config/conversation) for a real user.
          Also suppressed on admin pages: the launcher/panel float over the
          admin UI (and print output) with nothing useful to offer there. */}
      {user && !isAdminRoute && (
        <ChatProvider>
          <ChatWidget />
        </ChatProvider>
      )}
    </div>
  );
}
